import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { authService } from "../firebase/firebase";
import { authServiceApi } from "../api/authService";
import { setCredentials, logout, setAuthReady } from "../redux/authSlice";

export default function AuthProvider({ children }) {
  const dispatch = useDispatch();

  useEffect(() => {
    const unsubscribe = authService.onAuthStateChanged(async (firebaseUser) => {
      if (!firebaseUser) {
        dispatch(logout());
        dispatch(setAuthReady());
        return;
      }

      try {
        const token = await authService.getIdToken(firebaseUser);
        const role = await authServiceApi.getCurrentUserRole(firebaseUser.uid);

        dispatch(
          setCredentials({
            token,
            refreshToken: firebaseUser.refreshToken,
            role,
            uid: firebaseUser.uid,
            email: firebaseUser.email,
            expiryTime: Date.now() + 3600 * 1000,
          })
        );
      } catch (error) {
        dispatch(logout());
      } finally {
        dispatch(setAuthReady());
      }
    });

    return () => unsubscribe();
  }, [dispatch]);

  return children;
}
